"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishListPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var selection_1 = require("../../reducers/slices/selection");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var get_favourite_products_1 = require("../../api/calls/product/get_favourite_products");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var favourite_product_1 = require("../../api/calls/product/favourite_product");
var main_1 = require("../../reducers/slices/main");
var add_product_thunk_1 = require("../../reducers/slices/basket/thunks/add_product_thunk");
var image_default_png_1 = __importDefault(require("../../assets/image_default.png"));
var page_path_1 = require("./components/page_path");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
var WishListPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_1.useState)(null), productsList = _a[0], setProductsList = _a[1];
    var _b = (0, react_1.useState)([]), productsMapped = _b[0], setProductsMapped = _b[1];
    var _c = (0, react_1.useState)(true), isLoading = _c[0], setIsLoading = _c[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    (0, react_1.useEffect)(function () {
        init();
    }, [user]);
    var init = function () {
        if (user.integration_id) {
            setIsLoading(true);
            (0, get_favourite_products_1.get_favourite_products)().then(function (response) {
                setProductsList(response.content);
                setIsLoading(false);
            });
        }
    };
    (0, react_1.useEffect)(function () {
        if (productsList && productsList.length > 0) {
            var mappedProducts = [];
            var _loop_1 = function (product) {
                mappedProducts.push({
                    _id: product === null || product === void 0 ? void 0 : product._id,
                    image: (product === null || product === void 0 ? void 0 : product.image_url) ? product === null || product === void 0 ? void 0 : product.image_url : image_default_png_1.default,
                    title: product === null || product === void 0 ? void 0 : product.title,
                    titleColor: "text-black",
                    amount: product === null || product === void 0 ? void 0 : product.price,
                    borderColor: "border-none",
                    amountColor: "text-secondary",
                    shadowColor: "shadow-shadows",
                    //  rating: product?.rating?.average ?? 0,
                    discountLabel: (product === null || product === void 0 ? void 0 : product.on_promotion) ? "ON PROMOTION" : "",
                    discountAmount: (product === null || product === void 0 ? void 0 : product.on_promotion) ? product === null || product === void 0 ? void 0 : product.promotion_price : null,
                    pid: product === null || product === void 0 ? void 0 : product.pid,
                    sku: product === null || product === void 0 ? void 0 : product.sku,
                    sub_title: product === null || product === void 0 ? void 0 : product.sub_title,
                    description: product === null || product === void 0 ? void 0 : product.description,
                    instruction: product === null || product === void 0 ? void 0 : product.instruction,
                    estimated_delivery_time: product === null || product === void 0 ? void 0 : product.estimated_delivery_time,
                    promotion_price: product === null || product === void 0 ? void 0 : product.promotion_price.toString(),
                    on_promotion: product === null || product === void 0 ? void 0 : product.on_promotion,
                    extraText: product.estimated_delivery_time ? "Estimated Delivery: ".concat(product.estimated_delivery_time, " ") : "",
                    outOfStock: (product === null || product === void 0 ? void 0 : product.availability) !== "ONLINE" || (product === null || product === void 0 ? void 0 : product.status) !== "AVAILABLE",
                    colors: {
                        discount: {
                            textColor: "text-white",
                            amountColor: "text-red-500",
                            backgroundColor: "bg-red-500",
                        },
                        extraText: {
                            textColor: "text-success",
                        },
                        outOfStock: {
                            textColor: "text-white",
                            backgroundColor: "bg-gray-400",
                        },
                    },
                    favorite: {
                        icon: pro_solid_svg_icons_1.faHeart,
                        iconColor: "text-red-500",
                        onClick: function () {
                            (0, favourite_product_1.favorite_product)({
                                product_id: product._id,
                            }).then(function (response) {
                                if (response.success) {
                                    init();
                                    dispatch((0, main_1.setMessageModal)({
                                        title: "Success",
                                        messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                    }));
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({
                                        title: "Failed",
                                        messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                    }));
                                }
                            });
                        },
                    },
                });
            };
            for (var _i = 0, _a = productsList !== null && productsList !== void 0 ? productsList : []; _i < _a.length; _i++) {
                var product = _a[_i];
                _loop_1(product);
            }
            setProductsMapped(mappedProducts);
        }
        else {
            setProductsMapped([]);
        }
    }, [productsList]);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-4" },
            react_1.default.createElement(page_path_1.PagePath, { path: [
                    {
                        page: "/",
                        title: "Home",
                    },
                    {
                        page: "",
                        title: "Wishlist",
                        active: true,
                    },
                ] }),
            isLoading ? (react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null)) : productsMapped.length > 0 ? (react_1.default.createElement(doshx_controls_web_1.ProductsBigControl, { imageFit: "contain", canIncrement: true, button: {
                    label: "Cart",
                    borderColor: "border-secondary",
                    backgroundColor: "bg-secondary",
                    textColor: "text-white",
                    onClick: function (product) {
                        dispatch((0, add_product_thunk_1.add_product_thunk)(__assign({}, product)));
                    },
                }, products: productsMapped, onClick: function (product) {
                    dispatch((0, selection_1.setSelectedProduct)(product));
                    navigate("/product/".concat(product._id));
                } })) : (react_1.default.createElement("div", { className: "flex flex-col items-center gap-4" },
                react_1.default.createElement("div", { className: "flex flex-row justify-center items-center gap-2 text-gray-600" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faCartCircleExclamation, size: "4x" })),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your Wishlist is Empty", size: "3xlarge", textColor: "text-primary", center: true, bold: true }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Oops! It looks like your wishlist is currently empty. Don't worry, you can start adding your favorite items by browsing our collection.", size: "medium", textColor: "text-primary", center: true }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Simply click on the heart icon next to the items you love, and they'll be added to your wishlist for easy access later.", size: "medium", textColor: "text-primary", center: true }))))));
};
exports.WishListPage = WishListPage;
